import * as Scrivito from "scrivito"
import { Icon } from "shared/ui/icon/Icon"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { FeatureOverviewItemWidget } from "./FeatureOverviewItemWidgetClass"
import "./styles/_feature-overview-item-widget.scss"

Scrivito.provideComponent(FeatureOverviewItemWidget, ({ widget }) => {
  return (
    <div className="feature-overview-item-widget">
      <Icon
        name={widget.get("icon") as IconName}
        className="feature-overview-item-widget__icon"
      />

      <div className="feature-overview-item-widget__text">
        <Scrivito.ContentTag
          className="feature-overview-item-widget__title"
          content={widget}
          attribute="title"
          tag="h3"
        />

        <Scrivito.ContentTag
          className="feature-overview-item-widget__subtitle"
          content={widget}
          attribute="subtitle"
          tag="p"
        />
      </div>
    </div>
  )
})
